{"RZVjfY":[{"type":0,"value":"You will receive a response within one day."}],"aXLE6j":[{"type":0,"value":"My "},{"type":1,"value":"island"}]}